class PdpUpsellItemAddOn extends HTMLElement {
  constructor() {
    super();
  }
  // Method called when the element is connected to the document.
  connectedCallback() {
    this.initItems();
    this.customEventListeners();
  }

  // Method called when the element is disconnected from the document.
  disconnectedCallback() {
    this.removeEventListener(
      "pdp-upsell-single-add-on-item-change",
      this.singleAddOnItemEventHandler.bind(this)
    );
  }

  // Initializes the add-on items by querying necessary DOM elements.
  initItems() {
    this.section = this;
    this.addOnTotal = this.section.querySelector("#add-on-total");
    this.addOnTotalComparePrice = this.section.querySelector(
      "#add-on-total-compare-price"
    );
  }

  // Sets up custom event listeners for the component.
  customEventListeners() {
    this.addEventListener(
      "pdp-upsell-single-add-on-item-change",
      this.singleAddOnItemEventHandler.bind(this)
    );
  }

  /**
   * Event handler for single add-on item change events.
   * Dispatches a custom event indicating the add-on item has changed.
   */
  singleAddOnItemEventHandler() {
    this.dispatchEvent(
      new CustomEvent("pdp-upsell-item-add-on-change", {
        bubbles: true,
      })
    );
  }

  /**
   * Retrieves the currently checked add-on items and their quantities.
   * @returns {Array<Object>} Array of objects representing checked add-on items and their quantities.
   */
  getCheckedItems() {
    return Array.from(
      this.section.querySelectorAll(
        `pdp-upsell-single-add-on-item input[type="checkbox"]:checked`
      )
    ).map((el) => {
      const { addonItemHandle } = el.dataset;
      const quantity = el
        .closest(".pdp-upsell-addon-item")
        .querySelector(
          `pdp-upsell-quantity-controls input[type="number"]`
        ).value;

      return {
        addonItemHandle,
        quantity: parseInt(quantity),
      };
    });
  }

  /**
   * Sets the total and compare price total for the add-on items.
   * @param {number} total - The total price of add-on items.
   * @param {number} comparePriceTotal - The compare price total of add-on items.
   */
  setAddOnTotals(total, comparePriceTotal) {
    this.addOnTotal.value = total;
    this.addOnTotalComparePrice.value = comparePriceTotal;
  }

  /**
   * Retrieves the total and compare price total for the add-on items.
   * @returns {Object} An object containing the total and compare price total.
   */
  getAddOnTotals() {
    return {
      total: parseFloat(this.addOnTotal.value),
      totalComparePrice: parseFloat(this.addOnTotalComparePrice.value),
    };
  }

  /**
   * Checks the availability of variants for the given products and updates the DOM accordingly.
   * @param {Array<Object>} products - Array of product objects containing handle and availability information.
   */
  checkVariantAvailability(products) {
    products.forEach(({ productHandle, isVariantAvailable }) => {
      const item = this.section.querySelector(
        `.pdp-upsell-addon-item[data-addon-item-handle="${productHandle}"]`
      );
      if (item) item.dataset.variantAvailable = isVariantAvailable;
    });
  }

  /**
   * Resets the values of all add-on items, clearing availability and unchecking checkboxes.
   */
  resetValues() {
    this.section.querySelectorAll(`.pdp-upsell-addon-item`).forEach((el) => {
      el.dataset.variantAvailable = "";
      el.querySelector(`input[type="checkbox"]`).checked = false;
    });
  }
}
customElements.define("pdp-upsell-item-add-on", PdpUpsellItemAddOn);
